<template>
    <v-container>
        <v-btn fab color="orange darken-1" class="mt-2" @click="openNew">
            <v-icon class="white--text">mdi-account-plus-outline</v-icon>
        </v-btn>
        <template v-for="(tipo, index) in tipos">
            <h5>{{ tipo.nombre }}</h5>
            <v-data-table
                dense
                hide-default-footer
                disable-pagination
                :headers="headers[index]"
                :items="items.filter((element) => element.id_tipo == tipo.id)"
                item-key="id"
                class="elevation-4"
            >
                <template v-slot:item.action="{ item }">
                    <v-icon
                        @click="openEdit(item)"
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                    <v-icon
                        @click="openDeleteDialog(item)"
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </template>
            </v-data-table>
        </template>
        <table>
            <tr>
                <th></th>
                <th>Total</th> 
                <th>{{ totalNoMateria }}</th>
            </tr>
            <tr>
                <th></th>
                <th>COSTE MATERIA PRIMA</th>
                <th>{{ totalMateria }}</th>
            </tr>
            <tr>
                <th></th>
                <th>Total 1</th>
                <th>{{ total1 }}</th>
            </tr>
            <tr>
                <th>HORAS NOCTURNAS</th>
                <th>
                    <v-text-field
                        type="number"
                        v-model="orden_calculo.horas_extra"
                    ></v-text-field>
                </th>
                <th>{{ horas_extra }}</th>
            </tr>

            <tr>
                <th>INCIDENCIAS</th>
                <th>
                    <v-text-field
                        type="number"
                        v-model="orden_calculo.incidencias"
                    ></v-text-field>
                </th>
                <th>{{ incidencias }}</th>
            </tr>
            <tr>
                <th>DESCUETOS</th>
                <th>
                    <v-text-field
                        type="number"
                        v-model="orden_calculo.descuentos"
                    ></v-text-field>
                </th>
                <th>{{ descuentos }}</th>
            </tr>
            <tr>
                <th>IMPUESTOS</th>
                <th>
                    <v-text-field
                        type="number"
                        v-model="orden_calculo.impuestos"
                    ></v-text-field>
                </th>
                <th>{{ impuestos }}</th>
            </tr>
            <tr>
                <th>ESTRUCTURA</th>
                <th>
                    <v-text-field
                        type="number"
                        v-model="orden_calculo.estructura"
                    ></v-text-field>
                </th>
                <th>{{ estructura }}</th>
            </tr>
            <tr>
                <th>RESTO ESTRUCTURA</th>
                <th>
                    <v-text-field
                        type="number"
                        v-model="orden_calculo.resto_estructura"
                    ></v-text-field>
                </th>
                <th>{{ resto_estructura }}</th>
            </tr>
            <tr>
                <th></th>
                <th>Total 2</th>
                <th>{{ total2 }}</th>
            </tr>
            <tr>
                <th>BENEFICIO</th>
                <th>
                    <v-text-field
                        type="number"
                        v-model="orden_calculo.beneficio"
                    ></v-text-field>
                </th>
                <th>{{ beneficio }}</th>
            </tr>
            <tr>
                <th></th>
                <th>Total 3</th>
                <th>{{ total3 }}</th>
            </tr>
        </table>

        <v-dialog v-model="dialog_save" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Guardar objetivo
                </v-card-title>
                <v-card-text style="text-align: center">
                    <form ref="form_km">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-autocomplete
                                    label="Tipo"
                                    :items="tipos"
                                    v-model="item.id_tipo"
                                    item-text="nombre"
                                    item-value="id"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    label="Nombre"
                                    v-model="item.nombre"
                                ></v-text-field>
                            </v-col>
                            <template v-if="selectedTipo">
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        type="number"
                                        :label="selectedTipo.unidad_1"
                                        v-model="item.unidad_1"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="6"
                                    v-if="selectedTipo.unidad_2"
                                >
                                    <v-text-field
                                        type="number"
                                        :label="selectedTipo.unidad_2"
                                        v-model="item.unidad_2"
                                    ></v-text-field>
                                </v-col>
                            </template>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    type="number"
                                    label="Precio"
                                    v-model="item.precio"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </form>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog_save = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="save()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { debounce } from "../../../helpers";

export default {
    props: ["id_orden"],
    data() {
        return {
            tipos: [],
            headers: [],
            items: [],
            item: {},
            orden_calculo: {
                horas_extra: 0,
                incidencias: 0,
                descuentos: 0,
                impuestos: 0,
                estructura: 0,
                resto_estructura: 0,
                beneficio: 0,
            },

            dialog_save: false,
        };
    },
    mounted() {
        this.getTipos();
        this.getItems();
    },
    methods: {
        openNew() {
            this.item = {};
            this.dialog_save = true;
        },
        openEdit(item) {
            this.item = item;

            this.dialog_save = true;
        },
        SaveCalculo: debounce(function (val) {
            if (this.id_orden) {
                this.orden_calculo.id_orden = this.id_orden;
            }
            if (this.total3 > 0) {
                this.orden_calculo.total = this.total3;
            }
            axios
                .post("api/save-calculo-orden", this.orden_calculo)
                .then((res) => {
                    //this.orden_calculo= res.data;
                })
                .catch((error) => {
                    this.$custom_error(error.response.data);
                });
        }, 500),
        save() {
            if (this.id_orden) {
                this.item.id_orden = this.id_orden;
            }
            axios
                .post("api/save-item-orden", this.item)
                .then((res) => {
                    this.items = res.data;

                    this.dialog_save = false;
                })
                .catch((error) => {
                    this.$custom_error(error.response.data);
                });
        },
        getItems() {
            axios.get(`api/get-items-orden/${this.id_orden}`).then((res) => {
                this.items = res.data.items;
                this.orden_calculo = res.data.calc;
            });
        },
        getTipos() {
            axios.get(`api/get-tipos-gastos`).then(
                (res) => {
                    this.tipos = res.data;
                    this.tipos.forEach((element) => {
                        let header = [
                            {
                                text: "Nombre",
                                align: "left",
                                value: "nombre",
                            },
                            {
                                text: element.unidad_1,
                                align: "left",
                                value: "unidad_1",
                            },
                        ];
                        if (element.unidad_2 != null) {
                            header = header.concat([
                                {
                                    text: element.unidad_2,
                                    align: "left",
                                    value: "unidad_2",
                                },
                                {
                                    text: "Total",
                                    align: "left",
                                    value: "total",
                                },
                            ]);
                        }
                        header = header.concat([
                            {
                                text: "Precio",
                                align: "left",
                                value: "precio",
                            },
                            {
                                text: "Importe",
                                align: "left",
                                value: "importe",
                            },
                            {
                                text: "Acciones",
                                align: "left",
                                value: "action",
                            },
                        ]);
                        this.headers.push(header);
                    });
                    //console.log(this.headers);
                },
                (err) => {
                    this.$custom_error("Error consultando los objetivos");
                }
            );
        },
    },
    watch: {
        orden_calculo: {
            deep: true,
            handler: function (val) {
                this.SaveCalculo();
            },
        },
    },
    computed: {
        selectedTipo() {
            return (
                this.tipos.find((element) => element.id == this.item.id_tipo) ??
                {}
            );
        },
        totalMateria() {
            let total = 0;
            this.items
                .filter((element) => element.id_tipo == 1)
                .forEach((element) => {
                    total += element.importe;
                });
            return total;
        },
        totalNoMateria() {
            let total = 0;
            this.items
                .filter((element) => element.id_tipo != 1)
                .forEach((element) => {
                    total += element.importe;
                });
            return total;
        },
        total1() {
            return this.totalMateria + this.totalNoMateria;
        },
        horas_extra() {
            return (this.total1 * this.orden_calculo.horas_extra) / 100;
        },
        incidencias() {
            return (this.total1 * this.orden_calculo.incidencias) / 100;
        },
        descuentos() {
            return (this.total1 * this.orden_calculo.descuentos) / 100;
        },
        impuestos() {
            return (this.total1 * this.orden_calculo.impuestos) / 100;
        },
        estructura() {
            return (this.total1 * this.orden_calculo.estructura) / 100;
        },
        resto_estructura() {
            return (this.total1 * this.orden_calculo.resto_estructura) / 100;
        },
        total2() {
            return (
                this.total1 +
                this.horas_extra +
                this.incidencias +
                this.descuentos +
                this.impuestos +
                this.estructura +
                this.resto_estructura
            );
        },
        beneficio() {
            return (this.total2 * this.orden_calculo.beneficio) / 100;
        },
        total3() {
            return this.total2 + this.beneficio;
        },
    },
};
</script>
